const ExtensionsConstants = {
  BMP: 'bmp',
  GIF: 'gif',
  JPEG: 'jpeg',
  JPG: 'jpg',
  PNG: 'png',
};

export default ExtensionsConstants;
